import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "print:hidden"
}

import { ref } from 'vue';

const SUPPORT_URL =
  'https://support.leanlaw.co/conflict-checking-has-been-upgraded';

// Remembered, unlike the Overview notice's per-visit dismissal: this is an
// announcement, and one that reappears on every check stops being read. Versioned so a
// later announcement starts fresh rather than inheriting this dismissal.
const DISMISSED_KEY = 'conflictCheckUpgradeNotice.v2.dismissed';


export default /*@__PURE__*/_defineComponent({
  __name: 'ConflictUpgradeNotice',
  setup(__props) {

function wasDismissed(): boolean {
  try {
    return localStorage.getItem(DISMISSED_KEY) === 'true';
  } catch {
    // Storage blocked (private mode, a locked-down browser): show the notice — never
    // lose the announcement because the preference could not be read.
    return false;
  }
}

const visible = ref(!wasDismissed());

function dismiss(): void {
  visible.value = false;
  try {
    localStorage.setItem(DISMISSED_KEY, 'true');
  } catch {
    // Storage blocked: the notice is gone for this visit and returns next time, which
    // is the worst this can do. Nothing to report to the reviewer.
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_alert = _resolveComponent("v-alert")!

  return (visible.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_v_alert, {
          type: "info",
          variant: "tonal",
          density: "compact",
          closable: "",
          class: "mb-4 mt-4 text-sm",
          "data-cy": "conflict-upgrade-notice",
          "onClick:close": dismiss
        }, {
          text: _withCtx(() => [
            _cache[0] || (_cache[0] = _createTextVNode(" Conflict check has been upgraded: searches are more accurate, results are now split into full matches and partial matches, and you can save a check with your notes and find it later under Previous checks. ", -1)),
            _createElementVNode("a", {
              href: SUPPORT_URL,
              target: "_blank",
              rel: "noopener noreferrer",
              class: "underline",
              "data-cy": "conflict-upgrade-link"
            }, "Learn what changed")
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}
}

})